import React, { useState, ChangeEvent, KeyboardEvent } from "react";
import SearchProps from "../interfaces/SerarchProps";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import themestyle from "../theme";

const Search: React.FC<SearchProps> = ({ value, onChange, fullWidth, size = "small" }) => {
  const [query, setQuery] = useState(value);
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => setQuery(event.target.value);
  const handleSearchClick = () => onChange(query);
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onChange(query);
    }
  };
  const handleClear = () => {
    setQuery("");
    onChange("");
  };

  const isSmall = size === "small";

  return (
    <div style={{ display: "flex", alignItems: "center", marginRight: "10px", width: fullWidth ? "100%" : undefined }}>
      <TextField
        variant="outlined"
        size={size}
        value={query}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="Search..."
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        fullWidth={!!fullWidth}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton onClick={handleSearchClick}>
                <SearchIcon sx={{ color: "#666666", fontSize: isSmall ? 20 : 22 }} />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {query && (
                <IconButton onClick={handleClear}>
                  <CloseIcon sx={{ color: "#666666", fontSize: isSmall ? 20 : 22 }} />
                </IconButton>
              )}
            </InputAdornment>
          ),
          sx: {
            "& .MuiOutlinedInput-notchedOutline": { borderRadius: "50px" },
            "& .MuiInputBase-root": {
              backgroundColor: "#FFFFFF",
              border: "1px solid #C9CFD6",
              borderRadius: "50px",
              padding: "4px 12px",
              width: fullWidth ? "100%" : "250px",   // ← responsive width
              height: isSmall ? "34px" : "40px",
            },
            "& .MuiInputBase-input": {
              padding: "6px 0",
              fontSize: isSmall ? "13px" : "15px",
              color: "#6B7280",
              fontFamily: themestyle.fontFamily.Poppins,
              fontWeight: 400,
            },
            "& .MuiInputBase-input::placeholder": {
              color: "#9AA0A6",
              fontFamily: themestyle.fontFamily.Poppins,
              fontWeight: 400,
              opacity: 1,
            },
          },
        }}
        sx={{
          width: fullWidth ? "100%" : undefined,
          "& .MuiOutlinedInput-root": {
            "&:hover fieldset": { borderRadius: "50px" },
            "&.Mui-focused fieldset": { borderRadius: "50px" },
          },
        }}
      />
    </div>
  );
};

export default Search;
